import React, { useState, useEffect } from "react";
import CustomerDetails from "./CustomerDetails";
import { mergeDecrypted } from "../../utils/decrypt";

import CreateCustomerModal from "./CreateCustomerModal";
import {
  Table,
  Button,
  Input,
  Select,
  Space,
  Typography,
  Tag,
  Alert,
  Spin,
  Pagination,
  Card,
  Row,
  Col,
  Tooltip,
  message,
} from "antd";
import {
  Search,
  Filter,
  Upload,
  LogIn,
  ChevronRight,
  ChevronLeft,
  Users,
  ShoppingBag,
  Award,
  DollarSign,
  Eye,
} from "lucide-react";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
// import { mergeDecrypted } from "../utils/decrypt"; // adjust path to match your projecimport { merege }

const { Title, Text } = Typography;
const { Option } = Select;

const CustomersIndex = () => {
  const [viewCustomer, setViewCustomer] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [searchText, setSearchText] = useState("");
  const [hasOrdersFilter, setHasOrdersFilter] = useState(null);
  const [sortBy, setSortBy] = useState("-order_count");
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 20,
    total: 0,
  });
  const [summary, setSummary] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const { request } = useRequest();

  useEffect(() => {
    fetchCustomers();
  }, [
    pagination.currentPage,
    pagination.pageSize,
    searchText,
    hasOrdersFilter,
    sortBy,
  ]);

  // decrypted

  const fetchCustomers = () => {
    setLoading(true);
    setErrorMessage("");

    // Build query parameters
    const params = new URLSearchParams();
    params.append("page", pagination.currentPage);
    params.append("page_size", pagination.pageSize);

    if (searchText) {
      params.append("search", searchText);
    }

    if (hasOrdersFilter !== null) {
      params.append("has_orders", hasOrdersFilter);
    }

    if (sortBy) {
      params.append("sort_by", sortBy);
    }

    const url = `${apiPath.userOrderList}?${params.toString()}`;
    console.log(
      "Calling URL:",
      `${apiPath.userOrderList}?${params.toString()}`,
    );

    request({
      url: url,
      method: "GET",
      onSuccess: async (response) => {
        if (response?.success && response?.data) {
          const rawUsers = response.data.users || [];

          // Debug: see every row's raw secure value before decrypting
          rawUsers.forEach((u, i) => {
            console.log(
              `Row ${i} (id=${u.id}) secure:`,
              JSON.stringify(u.secure),
            );
          });

          const users = await Promise.all(
            rawUsers.map(async (user, index) => {
              try {
                return await mergeDecrypted(user);
              } catch (err) {
                console.error(
                  `Failed to decrypt user at index ${index} (id=${user.id}):`,
                  err.message,
                );
                return { ...user, decryptFailed: true };
              }
            }),
          );

          console.log(users);
          setCustomers(users);
          setPagination((prev) => ({
            ...prev,
            total: response.data.pagination?.total_records || 0,
          }));
          setSummary(response.data.summary);
          setSelectedRowKeys([]);
          setSelectedRows([]);
        } else {
          setCustomers([]);
          setErrorMessage(response?.message || "No customers found");
          setSelectedRowKeys([]);
          setSelectedRows([]);
        }
        setLoading(false);
      },
      onError: (err) => {
        console.error("Customers fetch error:", err);
        setErrorMessage(
          err?.response?.data?.message ||
            err?.message ||
            "Failed to load customers",
        );
        setCustomers([]);
        setLoading(false);
      },
    });
  };

  // const fetchCustomers = () => {
  //   setLoading(true);
  //   setErrorMessage("");

  //   // Build query parameters
  //   const params = new URLSearchParams();
  //   params.append("page", pagination.currentPage);
  //   params.append("page_size", pagination.pageSize);

  //   if (searchText) {
  //     params.append("search", searchText);
  //   }

  //   if (hasOrdersFilter !== null) {
  //     params.append("has_orders", hasOrdersFilter);
  //   }

  //   if (sortBy) {
  //     params.append("sort_by", sortBy);
  //   }

  //   const url = `${apiPath.userOrderList}?${params.toString()}`;

  //   request({
  //     url: url,
  //     method: "GET",
  //     onSuccess: async (response) => {
  //       if (response?.success && response?.data) {
  //         const users = response.data.users || [];
  //         console.log(users);
  //         const decryptedUsers = await Promise.all(
  //           users.map((user) =>
  //             mergeDecrypted(user).catch((err) => {
  //               console.error(`Failed to decrypt user id=${user.id}:`, err);
  //               const { secure, ...rest } = user;
  //               return rest;
  //             }),
  //           ),
  //         );
  //         console.log(decryptedUsers);

  //         setCustomers(decryptedUsers);
  //         setPagination((prev) => ({
  //           ...prev,
  //           total: response.data.pagination?.total_records || 0,
  //         }));
  //         setSummary(response.data.summary);
  //         setSelectedRowKeys([]);
  //         setSelectedRows([]);
  //       } else {
  //         setCustomers([]);
  //         setErrorMessage(response?.message || "No customers found");
  //         setSelectedRowKeys([]);
  //         setSelectedRows([]);
  //       }
  //       setLoading(false);
  //     },
  //     onError: (err) => {
  //       console.error("Customers fetch error:", err);
  //       setErrorMessage(
  //         err?.response?.data?.message ||
  //           err?.message ||
  //           "Failed to load customers",
  //       );
  //       setCustomers([]);
  //       setLoading(false);
  //     },
  //   });
  // };

  const handleSearch = (value) => {
    setSearchText(value);
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
  };

  const handleHasOrdersFilter = (value) => {
    setHasOrdersFilter(
      value === "all" ? null : value === "with" ? "true" : "false",
    );
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
  };

  const handleSortChange = (value) => {
    setSortBy(value);
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
  };

  const handlePageChange = (page, pageSize) => {
    setPagination({
      currentPage: page,
      pageSize: pageSize,
      total: pagination.total,
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const columns = [
    {
      title: "Customer Name",
      dataIndex: "name",
      key: "name",
      width: 180,
      render: (text) => (
        <div style={{ fontWeight: 500, color: "#1f2937", fontSize: "14px" }}>
          {text || "N/A"}
        </div>
      ),
    },

    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 240,
      render: (text) => (
        <div
          style={{
            color: "#6b7280",
            fontSize: "13px",
            wordBreak: "break-word",
          }}
        >
          {text || "N/A"}
        </div>
      ),
    },

    {
      title: "Phone",
      dataIndex: "phone_number",
      key: "phone_number",
      width: 150,
      render: (text) => (
        <div style={{ color: "#6b7280", fontSize: "13px" }}>
          {text || "N/A"}
        </div>
      ),
    },

    {
      title: "Status",
      key: "status",
      width: 120,
      render: (_, record) => (
        <Tag
          style={{
            backgroundColor: record.is_active ? "#10b981" : "#ef4444",
            color: "white",
            borderRadius: "12px",
            border: "none",
            padding: "2px 12px",
            fontSize: "12px",
            fontWeight: 500,
          }}
        >
          {record.is_active ? "Active" : "Inactive"}
        </Tag>
      ),
    },

    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      width: 130,
      render: (text) => (
        <div style={{ color: "#6b7280", fontSize: "13px" }}>
          {text || "Customer"}
        </div>
      ),
    },

    {
      title: "Orders",
      key: "orders",
      width: 100,
      align: "center",
      render: (_, record) => (
        <div
          style={{
            fontWeight: 600,
            color: "#1f2937",
            fontSize: "16px",
          }}
        >
          {record.order_count || 0}
        </div>
      ),
    },

    {
      title: "Points Spent",
      key: "points_spent",
      width: 140,
      align: "center",
      render: (_, record) => (
        <div
          style={{
            fontWeight: 500,
            color: "#8b5cf6",
            fontSize: "14px",
          }}
        >
          {parseFloat(record.total_points_spent || 0).toFixed(2)} pts
        </div>
      ),
    },

    {
      title: "Total Revenue",
      key: "revenue",
      width: 150,
      align: "right",
      render: (_, record) => (
        <div
          style={{
            fontWeight: 600,
            color: "#10b981",
            fontSize: "15px",
          }}
        >
          {parseFloat(record.total_orders_value || 0).toFixed(2)}
        </div>
      ),
    },

    {
      title: "Avg Order",
      key: "avg_order",
      width: 130,
      align: "right",
      render: (_, record) => (
        <div
          style={{
            color: "#64748b",
            fontSize: "13px",
          }}
        >
          {parseFloat(record.average_order_value || 0).toFixed(2)}
        </div>
      ),
    },

    {
      title: "First Order",
      key: "first_order",
      width: 140,
      render: (_, record) => (
        <div style={{ color: "#94a3b8", fontSize: "12px" }}>
          {record.first_order_date
            ? formatDate(record.first_order_date)
            : "N/A"}
        </div>
      ),
    },

    {
      title: "Last Order",
      key: "last_order",
      width: 140,
      render: (_, record) => (
        <div style={{ color: "#6b7280", fontSize: "13px" }}>
          {record.last_order_date
            ? formatDate(record.last_order_date)
            : "No orders yet"}
        </div>
      ),
    },

    {
      title: "Action",
      key: "actions",
      align: "center",
      width: 70,
      render: (_, record) => (
        <Tooltip title="View Details">
          <Button
            type="text"
            icon={<Eye size={18} style={{ color: "#2563eb" }} />}
            onClick={(e) => {
              e.stopPropagation();
              setViewCustomer(record);
            }}
          />
        </Tooltip>
      ),
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys, rows) => {
      setSelectedRowKeys(keys);
      setSelectedRows(rows);
    },
  };

  if (viewCustomer) {
    return (
      <CustomerDetails
        customer={viewCustomer}
        onBack={() => setViewCustomer(null)}
      />
    );
  }

  return (
    <div
      style={{
        padding: "24px",
        backgroundColor: "#fff",
        minHeight: "100vh",
        borderRadius: "8px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 24,
        }}
      >
        <Title level={3} style={{ margin: 0, fontWeight: 600 }}>
          Customers
        </Title>
        <Space>
          <Button
            icon={<Upload size={16} />}
            style={{
              display: "flex",
              alignItems: "center",
              borderRadius: "6px",
              color: "#64748b",
              fontWeight: 500,
            }}
            onClick={() => {
              // Export functionality
              const dataToExport =
                selectedRows.length > 0 ? selectedRows : customers;
              const exportData = dataToExport.map((c) => ({
                Name: c.name,
                Email: c.email,
                Phone: c.phone_number,
                Status: c.is_active ? "Active" : "Inactive",
                Role: c.role || "Customer",
                Orders: c.order_count,
                "Points Spent": c.total_points_spent,
                "Total Revenue": c.total_orders_value,
                "Average Order Value": c.average_order_value,
                "Customer Since": formatDate(c.created_at),
                "First Order": formatDate(c.first_order_date),
                "Last Order": formatDate(c.last_order_date),
              }));
              const csv = convertToCSV(exportData);
              const blob = new Blob([csv], { type: "text/csv" });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = `customers_${new Date().toISOString().split("T")[0]}.csv`;
              a.click();
              window.URL.revokeObjectURL(url);
              message.success(
                `${exportData.length} customers exported successfully`,
              );
            }}
          >
            Export {selectedRows.length > 0 && `(${selectedRows.length})`}
          </Button>
          {/* <Button 
                        type="primary" 
                        style={{ backgroundColor: '#3b82f6', borderColor: '#3b82f6', fontWeight: 500 }}
                        onClick={() => setIsModalVisible(true)}
                    >
                        Create Customer
                    </Button> */}
        </Space>
      </div>

      {/* Summary Cards */}
      {summary && (
        <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
          <Col span={24} md={8} xl={6}>
            <Card
              bordered
              style={{
                borderRadius: 12,
                height: "100%",
                boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <Text style={{ color: "#64748b", fontSize: "14px" }}>
                    Total Customers
                  </Text>
                  <div
                    style={{
                      marginTop: 8,
                      fontSize: 28,
                      fontWeight: 700,
                      color: "#0f172a",
                    }}
                  >
                    {summary.total_users}
                  </div>
                </div>
                <Users size={40} color="#3b82f6" />
              </div>
              <div style={{ marginTop: 12 }}>
                <Text style={{ fontSize: "12px", color: "#10b981" }}>
                  {summary.users_with_orders} with orders
                </Text>
                <Text
                  style={{ fontSize: "12px", color: "#64748b", marginLeft: 8 }}
                >
                  | {summary.users_without_orders} without orders
                </Text>
              </div>
            </Card>
          </Col>
          <Col span={24} md={8} xl={6}>
            <Card
              bordered
              style={{
                borderRadius: 12,
                height: "100%",
                boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <Text style={{ color: "#64748b", fontSize: "14px" }}>
                    Total Orders
                  </Text>
                  <div
                    style={{
                      marginTop: 8,
                      fontSize: 28,
                      fontWeight: 700,
                      color: "#0f172a",
                    }}
                  >
                    {summary.total_orders}
                  </div>
                </div>
                <ShoppingBag size={40} color="#8b5cf6" />
              </div>
            </Card>
          </Col>
          <Col span={24} md={8} xl={6}>
            <Card
              bordered
              style={{
                borderRadius: 12,
                height: "100%",
                boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <Text style={{ color: "#64748b", fontSize: "14px" }}>
                    Total Points Spent
                  </Text>
                  <div
                    style={{
                      marginTop: 8,
                      fontSize: 28,
                      fontWeight: 700,
                      color: "#8b5cf6",
                    }}
                  >
                    {parseFloat(summary.total_points_spent || 0).toFixed(2)} pts
                  </div>
                </div>
                <Award size={40} color="#f59e0b" />
              </div>
            </Card>
          </Col>
          <Col span={24} md={8} xl={6}>
            <Card
              bordered
              style={{
                borderRadius: 12,
                height: "100%",
                boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <Text style={{ color: "#64748b", fontSize: "14px" }}>
                    Avg points
                  </Text>
                  <div
                    style={{
                      marginTop: 8,
                      fontSize: 28,
                      fontWeight: 700,
                      color: "#10b981",
                    }}
                  >
                    {summary.total_users > 0
                      ? (
                          parseFloat(summary.total_points_spent || 0) /
                          summary.total_users
                        ).toFixed(2)
                      : "0.00"}{" "}
                    pts
                  </div>
                </div>
                {/* <DollarSign size={40} color="#10b981" /> */}
              </div>
            </Card>
          </Col>
        </Row>
      )}

      {/* Filters */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <Space size="large" wrap>
          <Input
            prefix={<Search size={16} color="#94a3b8" />}
            placeholder="Search by name, email or phone"
            value={searchText}
            onChange={(e) => handleSearch(e.target.value)}
            style={{ width: 300, borderRadius: "6px" }}
            allowClear
          />

          <Select
            defaultValue="all"
            style={{ width: 150 }}
            onChange={handleHasOrdersFilter}
            placeholder="Order Status"
          >
            <Option value="all">All Customers</Option>
            <Option value="with">With Orders</Option>
            <Option value="without">Without Orders</Option>
          </Select>

          <Select
            defaultValue="-order_count"
            style={{ width: 180 }}
            onChange={handleSortChange}
            placeholder="Sort By"
          >
            <Option value="-order_count">Most Orders</Option>
            <Option value="order_count">Least Orders</Option>
            <Option value="-total_points_spent">Most Points Spent</Option>
            <Option value="-total_orders_value">Highest Revenue</Option>
            <Option value="-created_at">Newest First</Option>
            <Option value="created_at">Oldest First</Option>
            <Option value="name">Name A-Z</Option>
            <Option value="-name">Name Z-A</Option>
          </Select>
        </Space>
      </div>

      {errorMessage && (
        <Alert
          type="error"
          message="Error loading customers"
          description={errorMessage}
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}

      <Table
        scroll={{ x: 1200 }}
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
        columns={columns}
        dataSource={customers}
        loading={loading}
        pagination={false}
        bordered
        rowKey="id"
        rowClassName={() => "custom-table-row"}
        className="custom-customers-table"
        locale={{ emptyText: loading ? "Loading..." : "No customers found" }}
      />

      {/* Pagination */}
      {customers.length > 0 && (
        <div
          style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}
        >
          <Pagination
            current={pagination.currentPage}
            pageSize={pagination.pageSize}
            total={pagination.total}
            onChange={handlePageChange}
            showSizeChanger
            showQuickJumper
            showTotal={(total, range) =>
              `${range[0]}-${range[1]} of ${total} customers`
            }
            pageSizeOptions={["10", "20", "50", "100"]}
          />
        </div>
      )}

      <CreateCustomerModal
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onSave={(values) => {
          console.log("Saved Address:", values);
          setIsModalVisible(false);
          fetchCustomers(); // Refresh the list
        }}
      />
    </div>
  );
};

// Helper function to convert to CSV
const convertToCSV = (data) => {
  if (!data || data.length === 0) return "";

  const headers = Object.keys(data[0]);
  const csvRows = [];

  csvRows.push(headers.join(","));

  for (const row of data) {
    const values = headers.map((header) => {
      const value = row[header] || "";
      const escaped = String(value).replace(/"/g, '""');
      return `"${escaped}"`;
    });
    csvRows.push(values.join(","));
  }

  return csvRows.join("\n");
};

export default CustomersIndex;
